// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__36zoO","signatureBlock":"Footer_signatureBlock__v3ovb","signature":"Footer_signature__PKx81"};